// extracted by mini-css-extract-plugin
export var actionText = "_jc-4";
export var container = "_jc-0";
export var leftSection = "_jc-1";
export var rightSection = "_jc-2";
export var settingsButton = "_jc-6";
export var settingsIcon = "_jc-7";
export var shortcut = "_jc-5";
export var shortcutGroup = "_jc-3";